<template>
  <div>
    <el-menu
      :default-active="defaultActive"
      background-color="#20222A"
      text-color="#BDBDC0"
      style="border: none;"
      router
      :collapse="collapse"
      :collapse-transition="false"
      @open="handleOpen"
      @close="handleClose">
      <!-- <el-menu-item index="/home">
        <i class="iconfont icon-gongzuotai"></i>
        <span slot="title">工作台</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/waitExamine">
        <i class="iconfont icon-check"></i>
        <span slot="title">待审核名片</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/copartner">
        <i class="iconfont icon-hehuoren"></i>
        <span slot="title">合伙人申请</span>
      </el-menu-item> -->
      <!-- 
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/agentSales">
        <i class="iconfont icon-xiaoshouyeji"></i>
        <span slot="title">代理商业绩</span>
      </el-menu-item> -->
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/finance">
        <i class="iconfont icon-caiwuguanli"></i>
        <span slot="title">财务管理</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/cash">
        <i class="iconfont icon-tixianguanli"></i>
        <span slot="title">提现管理</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/information">
        <i class="iconfont icon-qiyeguanli"></i>
        <span slot="title">企业管理</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/personal">
        <i class="iconfont icon-mingpianguanli"></i>
        <span slot="title">名片管理</span>
      </el-menu-item>
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/cards">
        <i class="iconfont icon-mingpianguanli"></i>
        <span slot="title">矩阵名片</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/cards2">
        <i class="iconfont icon-mingpianguanli"></i>
        <span slot="title">矩阵名片2</span>
      </el-menu-item> -->
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/agent">
        <i class="iconfont icon-hehuoren"></i>
        <span slot="title">合伙人管理</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/proxy">
        <i class="iconfont icon-dailishangguanli"></i>
        <span slot="title">代理商管理</span>
      </el-menu-item>
       <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/ebook">
        <i class="iconfont icon-huaceguanli"></i>
        <span slot="title">画册管理</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/classify">
        <i class="iconfont icon-chanpinfenlei"></i>
        <span slot="title">产品分类</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/product">
        <i class="iconfont icon-chanpinguanli"></i>
        <span slot="title">产品中心</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/order">
        <i class="iconfont icon-dingdandaifukuan"></i>
        <span slot="title">订单管理</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/viewCard">
        <i class="iconfont icon-liulanjilu"></i>
        <span slot="title">浏览记录</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="userPrower == '1'" index="/sonAccount">
        <i class="iconfont icon-a-icon16-0zhanweifu5"></i>
        <span slot="title">系统账号管理</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="userPrower == '1'" index="/companyAccount">
        <i class="iconfont icon-zizhanghaoguanli"></i>
        <span slot="title">企业账号管理</span>
      </el-menu-item> -->
      <!-- <el-menu-item v-if="userPrower == '1'" index="/personalAccount">
        <i class="iconfont icon-xingming"></i>
        <span slot="title">个人账号管理</span>
      </el-menu-item> -->


      <!-- <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/store">
        <i class="iconfont icon-mendianguanli"></i>
        <span slot="title">网点管理</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/employee">
        <i class="iconfont icon-yuangongguanli"></i>
        <span slot="title">员工管理</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/preactivity">
        <i class="iconfont icon-shujushangbao"></i>
        <span slot="title">活动计划</span>
      </el-menu-item>
      <el-menu-item v-else index="/preactivity/examine">
        <i class="iconfont icon-shujushangbao"></i>
        <span slot="title">活动计划</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/activity">
        <i class="iconfont icon-liwuhuodong"></i>
        <span slot="title">活动管理</span>
      </el-menu-item>
      <el-menu-item v-else index="/activity/examine">
        <i class="iconfont icon-liwuhuodong"></i>
        <span slot="title">活动管理</span>
      </el-menu-item>
      <el-menu-item v-if="['1', '2'].includes(userPrower)" index="/report">
        <i class="iconfont icon-tongji"></i>
        <span slot="title">统计报表</span>
      </el-menu-item>
      <el-menu-item v-else index="/report/examine">
        <i class="iconfont icon-tongji"></i>
        <span slot="title">统计报表</span>
      </el-menu-item>
      <el-menu-item v-if="userPrower == '1'" index="/sonAccount">
        <i class="iconfont icon--yuangong"></i>
        <span slot="title">子账号管理</span>
      </el-menu-item> -->

      <!-- <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>网点管理</span>
            </template>
            <el-menu-item index="2-1">新增网点</el-menu-item>
            <el-menu-item index="2-2">网点列表</el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>导航一</span>
        </template>
        <el-menu-item index="2-1">选项1</el-menu-item>
        <el-menu-item index="2-2">选项2</el-menu-item>
      </el-submenu> -->
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'WebMenuBar',
  props: {
    collapse: {
      type: Boolean,
      default: false
    },
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      userPrower: '',
      defaultActive: ''
    };
  },
  watch: {
    active(value) {
      if (value == 'userCenter' || value == 'updatePwd') {
        this.defaultActive = ''
      }
    }
  },
  mounted() {
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      this.userPrower = userInfo.prower
    } else {
      this.$http({
        method: 'post',
        url: 'user_exit'
      })
      this.$router.push({
        path: '/login'
      })
    }
    this.defaultActive = this.$route.path
  },

  methods: {
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    }
  },
};
</script>

<style lang="scss" scoped>
.el-menu {
  animation: 1s;
}
.el-menu-item.is-active {
  background: #3399FF !important;
  color: #FFFFFF;
}
.iconfont {
  margin-right: 10px;
}
</style>